export default class HeaderMenu {
    constructor($el)  {
        this.$el = $el;
        this.$hamburger = document.querySelector('[data-hamburger="mobile"]');
        this.$close = this.$el.querySelector('[data-menu-close="mobile"]');

        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);

        this.$hamburger.addEventListener('click', this.openMenu)
        this.$close.addEventListener('click', this.closeMenu)


    }

    openMenu(e) {
        e.preventDefault();
        this.$el.classList.add('header__menu--open');
    }

    closeMenu(e) {
        e.preventDefault();
        this.$el.classList.remove('header__menu--open');
    }
}